import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { track } from '@/modules/shared/lib/analytics/tracker'
import type { EventTypeEnum } from '@/generated/user-events-tracking/types'

export function useTrackPageView(): void {
  const location = useLocation()
  const prevPathRef = useRef<string>('')

  useEffect(() => {
    const prevPath = prevPathRef.current || ''

    track('page_view' as EventTypeEnum, {
      page: location.pathname,
      referrer: prevPath,
    })

    prevPathRef.current = location.pathname
  }, [location.pathname])
}
